'use strict';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var isPlainObject = require('./isPlainObject.js');
var getSymbols = require('../compat/_internal/getSymbols.js');
var getTag = require('../compat/_internal/getTag.js');
var tags = require('../compat/_internal/tags.js');
var eq = require('../compat/util/eq.js');
function isEqualWith(a, b, areValuesEqual) {
    return isEqualWithImpl(a, b, undefined, undefined, undefined, undefined, areValuesEqual);
}
function isEqualWithImpl(a, b, property, aParent, bParent, stack, areValuesEqual) {
    var result = areValuesEqual(a, b, property, aParent, bParent, stack);
    if (result !== undefined) {
        return result;
    }
    if ((typeof a === "undefined" ? "undefined" : _type_of(a)) === (typeof b === "undefined" ? "undefined" : _type_of(b))) {
        switch(typeof a === "undefined" ? "undefined" : _type_of(a)){
            case 'bigint':
            case 'string':
            case 'boolean':
            case 'symbol':
            case 'undefined':
                {
                    return a === b;
                }
            case 'number':
                {
                    return a === b || Object.is(a, b);
                }
            case 'function':
                {
                    return a === b;
                }
            case 'object':
                {
                    return areObjectsEqual(a, b, stack, areValuesEqual);
                }
        }
    }
    return areObjectsEqual(a, b, stack, areValuesEqual);
}
function areObjectsEqual(a, b, stack, areValuesEqual) {
    if (Object.is(a, b)) {
        return true;
    }
    var aTag = getTag.getTag(a);
    var bTag = getTag.getTag(b);
    if (aTag === tags.argumentsTag) {
        aTag = tags.objectTag;
    }
    if (bTag === tags.argumentsTag) {
        bTag = tags.objectTag;
    }
    if (aTag !== bTag) {
        return false;
    }
    switch(aTag){
        case tags.stringTag:
            return a.toString() === b.toString();
        case tags.numberTag:
            {
                var x = a.valueOf();
                var y = b.valueOf();
                return eq.eq(x, y);
            }
        case tags.booleanTag:
        case tags.dateTag:
        case tags.symbolTag:
            return Object.is(a.valueOf(), b.valueOf());
        case tags.regexpTag:
            {
                return a.source === b.source && a.flags === b.flags;
            }
        case tags.functionTag:
            {
                return a === b;
            }
    }
    stack = stack !== null && stack !== void 0 ? stack : new Map();
    var aStack = stack.get(a);
    var bStack = stack.get(b);
    if (aStack != null && bStack != null) {
        return aStack === b;
    }
    stack.set(a, b);
    stack.set(b, a);
    try {
        switch(aTag){
            case tags.mapTag:
                {
                    if (a.size !== b.size) {
                        return false;
                    }
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = a.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                            if (!b.has(key) || !isEqualWithImpl(value, b.get(key), key, a, b, stack, areValuesEqual)) {
                                return false;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return true;
                }
            case tags.setTag:
                {
                    var _loop = function(i) {
                        var aValue = aValues[i];
                        var index = bValues.findIndex(function(bValue) {
                            return isEqualWithImpl(aValue, bValue, undefined, a, b, stack, areValuesEqual);
                        });
                        if (index === -1) {
                            return {
                                v: false
                            };
                        }
                        bValues.splice(index, 1);
                    };
                    if (a.size !== b.size) {
                        return false;
                    }
                    var aValues = Array.from(a.values());
                    var bValues = Array.from(b.values());
                    for(var i = 0; i < aValues.length; i++){
                        var _ret = _loop(i);
                        if (_type_of(_ret) === "object") return _ret.v;
                    }
                    return true;
                }
            case tags.arrayTag:
            case tags.uint8ArrayTag:
            case tags.uint8ClampedArrayTag:
            case tags.uint16ArrayTag:
            case tags.uint32ArrayTag:
            case tags.bigUint64ArrayTag:
            case tags.int8ArrayTag:
            case tags.int16ArrayTag:
            case tags.int32ArrayTag:
            case tags.bigInt64ArrayTag:
            case tags.float32ArrayTag:
            case tags.float64ArrayTag:
                {
                    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(a) !== Buffer.isBuffer(b)) {
                        return false;
                    }
                    if (a.length !== b.length) {
                        return false;
                    }
                    for(var i1 = 0; i1 < a.length; i1++){
                        if (!isEqualWithImpl(a[i1], b[i1], i1, a, b, stack, areValuesEqual)) {
                            return false;
                        }
                    }
                    return true;
                }
            case tags.arrayBufferTag:
                {
                    if (a.byteLength !== b.byteLength) {
                        return false;
                    }
                    return areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
                }
            case tags.dataViewTag:
                {
                    if (a.byteLength !== b.byteLength || a.byteOffset !== b.byteOffset) {
                        return false;
                    }
                    return areObjectsEqual(new Uint8Array(a), new Uint8Array(b), stack, areValuesEqual);
                }
            case tags.errorTag:
                {
                    return a.name === b.name && a.message === b.message;
                }
            case tags.objectTag:
                {
                    var areEqualInstances = areObjectsEqual(a.constructor, b.constructor, stack, areValuesEqual) || isPlainObject.isPlainObject(a) && isPlainObject.isPlainObject(b);
                    if (!areEqualInstances) {
                        return false;
                    }
                    var aKeys = _to_consumable_array(Object.keys(a)).concat(_to_consumable_array(getSymbols.getSymbols(a)));
                    var bKeys = _to_consumable_array(Object.keys(b)).concat(_to_consumable_array(getSymbols.getSymbols(b)));
                    if (aKeys.length !== bKeys.length) {
                        return false;
                    }
                    for(var i2 = 0; i2 < aKeys.length; i2++){
                        var propKey = aKeys[i2];
                        var aProp = a[propKey];
                        if (!Object.hasOwn(b, propKey)) {
                            return false;
                        }
                        var bProp = b[propKey];
                        if (!isEqualWithImpl(aProp, bProp, propKey, a, b, stack, areValuesEqual)) {
                            return false;
                        }
                    }
                    return true;
                }
            default:
                {
                    return false;
                }
        }
    } finally{
        stack.delete(a);
        stack.delete(b);
    }
}
exports.isEqualWith = isEqualWith;
